// extracted by mini-css-extract-plugin
export var contentBody = "_bq-9";
export var headerImage = "_bq-2";
export var imageButton = "_bq-7";
export var imageButtonIcon = "_bq-8";
export var imageHeader = "_bq-4";
export var imageHeaderText = "_bq-5";
export var imageOverlay = "_bq-3";
export var imageTitle = "_bq-6";
export var imageWrapper = "_bq-1";
export var taskList = "_bq-a";
export var widget = "_bq-0";